import React, { useId } from "react";
import { usePageTheme } from "../theme/usePageTheme";

interface V2SendIconProps {
  size?: number;
  className?: string;
}

/** 输入栏发送按钮 — flya.svg，填充与用户消息气泡背景一致（180deg 渐变） */
const V2SendIcon: React.FC<V2SendIconProps> = ({ size = 28, className }) => {
  const { tokens } = usePageTheme();
  const uid = useId().replace(/:/g, "");
  const fillId = `uchat-send-fill-${uid}`;
  const height = (size * 24) / 28;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 28 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <defs>
        <linearGradient id={fillId} x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor={tokens.chatUserGradientStart} />
          <stop offset="100%" stopColor={tokens.chatUserGradientEnd} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${fillId})`}
        fillRule="nonzero"
        d="M27.2280886,0.574493659 C26.5878026,0.0110714722 25.6906354,-0.151526877 24.8854853,0.147200323 L1.48629121,8.86700946 C0.615962342,9.19220616 0.0446892103,9.96360298 0.00251468379,10.8824727 C-0.0396598427,11.8013425 0.451098284,12.6218969 1.29075477,13.0265021 L4.94460238,14.7886145 C5.01744929,14.8226467 5.0826281,14.8718043 5.14013882,14.9247433 C5.51970956,15.8889893 7.01882227,19.6665649 7.6859466,21.0316348 C8.02334281,21.7274045 8.64445857,22.2151995 9.21956574,22.4269555 C9.18122527,22.4231741 9.13905074,22.4156114 9.09304217,22.4080487 C9.20422955,22.4496436 9.31925099,22.4836759 9.43810647,22.506364 C10.1972479,22.6576183 10.9755597,22.4269555 11.5199945,21.8862215 L12.8810815,20.5438397 C13.1226265,20.3056143 13.5021972,20.2526753 13.8012529,20.419055 L19.6635121,23.7012728 C20.0162445,23.8979034 20.4073174,24 20.7983903,24 C21.1051141,24 21.415672,23.9394983 21.7070596,23.8147135 C22.374184,23.5311117 22.857274,22.9714709 23.0336402,22.2757012 L27.9297193,2.80927562 C28.1405919,1.99250252 27.8683745,1.13413449 27.2280886,0.574493659 L27.2280886,0.574493659 Z M6.59707701,14.4596364 L19.1420816,7.38093618 L12.0605952,14.5352635 C11.9455738,14.6524856 11.8612247,14.7848331 11.803714,14.9398687 C11.79988,14.9474314 11.79988,14.9512128 11.7960459,14.9587755 C11.7807097,15.0041518 10.3812822,19.0766732 9.55312791,20.9181941 C9.3844298,20.8085347 9.18122527,20.630811 9.06236978,20.3850228 C8.44892212,19.1144868 7.01882227,15.5184163 6.59707701,14.4596364 Z"
      />
    </svg>
  );
};

export default V2SendIcon;
